module.exports = __webpack_public_path__ + "fonts/Lato-700-latin-ext7.33c9065.woff2";